@if (!isLoading() && totalItemCount() === 0 && filteredColumns().length === 0) {
  <div>{{ 'dataManagement.exportList.noExports' | transloco }}</div>
} @else {
  <div class="table-scroll-container">
    <table
      mat-table
      [dataSource]="tableDataSource()"
      class="export-list-table row__content--button-header-aligned"
      [fixedLayout]="true"
      matSort
      matSortDisableClear
      [matSortDirection]="getActiveSortDirection()"
      [matSortActive]="getActiveSortColumn()"
      (matSortChange)="onSortChanged($event)">
      <ng-container matColumnDef="organization">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: paginationFields.OrganizationId, categories: organizationOptions() }"
              type="button">
              {{ 'dataManagement.exportList.columns.exportedToOrganizations' | transloco }}
              @if (filteredColumns().includes(paginationFields.OrganizationId)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.exportedToOrganization.name }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="importCandidateId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.filterMenu"
              [matMenuTriggerData]="{ caller: paginationFields.ImportCandidateId, integerOnly: true }"
              type="button">
              {{ 'dataManagement.exportList.columns.importCandidateId' | transloco }}
              @if (filteredColumns().includes(paginationFields.ImportCandidateId)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '50%'">{{ element.importCandidateId }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="exportTimestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" type="button">
              {{ 'dataManagement.exportList.columns.exportTimestamp' | transloco }}
              @if (filteredColumns().includes('exportTimestamp')) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">
            @if (element.exportTimestamp.getTime() < 0) {
              -
            } @else {
              {{ element.exportTimestamp | date: 'short' }}
            }
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="exportProfile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.filterMenu"
              [matMenuTriggerData]="{ caller: paginationFields.ExportProfile }"
              type="button">
              {{ 'dataManagement.exportList.columns.exportProfile' | transloco }}
              @if (filteredColumns().includes(paginationFields.ExportProfile)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '60%'">{{ element.exportProfile?.profileName ?? '-' }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: paginationFields.Status, categories: statusOptions }"
              type="button">
              {{ 'dataManagement.exportList.columns.status' | transloco }}
              @if (filteredColumns().includes(paginationFields.Status)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '50%'">{{ 'dataManagement.exportList.status.' + element.status | transloco }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="tracking">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: paginationFields.Tracking, categories: trackingOptions }"
              type="button">
              {{ 'dataManagement.exportList.columns.tracking' | transloco }}
              @if (filteredColumns().includes(paginationFields.Tracking)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '40%'">{{
            'dataManagement.exportList.tracking.' + (element.tracking ? 'on' : 'off') | transloco
          }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="packagingId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: paginationFields.Id, integerOnly: true }" type="button">
              {{ 'dataManagement.exportList.columns.packagingId' | transloco }}
              @if (filteredColumns().includes(paginationFields.Id)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '40%'">{{ element.exportedPackaging.id }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: paginationFields.ProductName }" type="button">
              {{ 'dataManagement.exportList.columns.name' | transloco }}
              @if (filteredColumns().includes(paginationFields.ProductName)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.exportedPackaging.productName }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="articleName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: paginationFields.ArticleName }" type="button">
              {{ 'dataManagement.exportList.columns.name' | transloco }}
              @if (filteredColumns().includes(paginationFields.ArticleName)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.exportedPackaging.articleName }}</ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: paginationFields.Version }" type="button">
              {{ 'dataManagement.exportList.columns.version' | transloco }}
              @if (filteredColumns().includes(paginationFields.Version)) {
                <mat-icon class="filter-icon">filter_alt</mat-icon>
              }
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '30%'">{{ element.exportedPackaging.version }}</ng-container>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *appSingleBlocSkeleton="isLoading(); width: '36px'; height: '24px'">
            <button mat-icon-button type="button" (click)="changeTrackingClicked(element)">
              <mat-icon>track_changes</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="deleteImportClicked(element)" [disabled]="element.status !== exportStatus.Shared && element.status !== exportStatus.Imported">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()" class="element-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns()?.length">
          {{ 'dataManagement.noFilteredResults' | transloco }}
        </td>
      </tr>

      <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource()"></app-filter-menu>
    </table>
  </div>

  <mat-paginator
    class="export-list-paginator"
    [pageSizeOptions]="pageSizeOptions()"
    [pageSize]="currentPageSize()"
    [length]="totalItemCount()"
    [pageIndex]="currentPageIndex()"
    showFirstLastButtons
    aria-label="Select page"
    (page)="onPageChanged($event)"></mat-paginator>
}
